import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { deleteExpense } from '#/graphql/mutations';

const q = gql(deleteExpense);

const useExpenseDelete = () => {
  const [mutation, result] = useMutation(q);

  const deleteExpense = useCallback(
    (expenseId: string) => {
      return mutation({
        variables: {
          id: expenseId,
        },
      });
    },
    [mutation],
  );

  return { deleteExpense, result };
};

export default useExpenseDelete;
